export const constants = {
	selector: {
		target: 'data-lazyselect',
		label: 'data-select-label',
		render: 'data-select-render',
		dynamicOptionAttribute: 'data-lazyselect-dynamic-option',
	},
	attribute: {
		url: 'data-lazyselect-url',
		limit: 'data-lazyselect-limit',
		placeholder: 'data-select-placeholder',
	},
	debounceMs: 300,
}
